export * from "./recommendations-page.view";